import preval from 'preval.macro'

import packageJson from '../../package.json'

export const buildTime = preval`module.exports = new Date().getTime();`
export const version = packageJson.version
